const StoredEntity = require('./stored-entity');

class RequestForm extends StoredEntity {

	constructor(step) {
		super();
		// this._step = step;
		Object.defineProperty(this, '_step', {
			value: step,
			enumerable: false,
			writable: false,
			configurable: false
		});
		this.fieldData = {};
		this.owner = '';
		this.filledBy = null;
		this.filledDate = null;
		this.attachments = [];
	}

	setOwner(owner) {
		this.owner = owner;
	}

	getStep() {
		return this._step;
	}

	fillData(data, attachments, userId) {
		if (this.filledDate) throw new Error('already filled');
		if (!this.getStep().isOpen()) throw new Error('step is not open');
		let target = {};
		this.getStep().getFields().forEach(({ id }) => {
			if (id in data) {
				target[id] = data[id];
			}
		});
		//validate against mandatory
		this.getStep().getFieldsLoaded().forEach((field) => {
			field.validateInput(target[field.getId()]);
		});
		this.fieldData = target;
		this.attachments = attachments;
		this.filledDate = new Date();
		if (userId !== this.owner) this.filledBy = userId;
	}

	getFilledDate() {
		return this.filledDate;
	}

	toStorage() {
		let d = super.toStorage();
		d.fieldData = JSON.stringify(d.fieldData);
		return d;
	}

	fromData(d) {
		// console.log('form fromData', d);
		super.fromData(d);
		if (typeof d.fieldData === 'string') this.fieldData = JSON.parse(d.fieldData);
		this.filledDate = d.filledDate ? new Date(d.filledDate) : null;
	}

	getDataByTag(tag, preferKey) {
		return Object.entries(this.fieldData).filter(([id]) => {
			let field = this.getStep().getFieldsLoaded().find(f => f.getId() === id);
			return field && field.getTags().includes(tag);
		}).map(([ id, val ]) => {
			if (!preferKey) return [id, val];
			let field = this.getStep().getFieldsLoaded().find(f => f.getId() === id);
			let opt = field.options.find(o => o.id === val);
			if (opt && opt.key) return [id, opt.key];	//prefer returning opt.key if available
			return [id, val];
		});
	}
}

module.exports = RequestForm;
